// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4yXRUSJY859ILYF00TvMOyUM-dAjdK4Q",
  authDomain: "cuppredict.firebaseapp.com",
  projectId: "cuppredict",
  storageBucket: "cuppredict.firebasestorage.app",
  messagingSenderId: "284653272010",
  appId: "1:284653272010:web:ef676c40695567c17a6d33",
  measurementId: "G-GRC50XKPCZ"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const storage = getStorage(app);
const analytics = getAnalytics(app);